// One confirmed add, then reconcile the existing theme drawer. Never retry POSTs.
const bounded = async (promise, ms = 10000) => {
  let timer;
  try { return await Promise.race([promise, new Promise((_, reject) => { timer = setTimeout(() => reject(new Error('Drawer unavailable')), ms); })]); }
  finally { clearTimeout(timer); }
};

document.addEventListener('click', async event => {
  const trigger = event.target.closest('cart-drawer-trigger');
  if (!trigger || customElements.get('cart-drawer-trigger')) return;
  event.preventDefault();
  const fallback = trigger.querySelector('a')?.href;
  try {
    await bounded(customElements.whenDefined('cart-drawer-trigger'));
    if (trigger.isConnected) trigger.click();
  } catch {
    if (fallback) location.assign(fallback);
  }
}, {capture:true});

export async function addToDrawer(items, addUrl, cartUrl) {
  let confirmed = false;
  try {
    const response = await fetch(addUrl, {
      method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
      body:JSON.stringify({items, sections:['g_cart-drawer'], sections_url:location.pathname + location.search}),
      signal:AbortSignal.timeout(15000)
    });
    const result = await response.json();
    if (!response.ok || result.status) {
      const failure = new Error(typeof result.description === 'string' ? result.description : 'Unable to add this selection.');
      failure.rejected = true;
      throw failure;
    }
    if (!Array.isArray(result.items) || !result.items.length) throw new Error('Unconfirmed cart response');
    confirmed = true;
    const section = result.sections?.['g_cart-drawer'];
    if (!section?.includes('cart-drawer-stash')) throw new Error('Missing drawer section');
    const metaResponse = await fetch(cartUrl + '?view=meta', {signal:AbortSignal.timeout(10000)});
    if (!metaResponse.ok) throw new Error('Missing cart summary');
    const meta = await metaResponse.json();
    if (!Number.isFinite(Number(meta.count))) throw new Error('Invalid cart summary');
    await bounded(customElements.whenDefined('cart-drawer'));
    // The existing drawer owns its DOM updates, quantity controls, modal and focus.
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) throw new Error('Drawer not mounted');
    document.dispatchEvent(new CustomEvent('cart:update', {detail:{data:{meta:{...meta,count:Number(meta.count)},drawer:{section,open:true}}}}));
  } catch (failure) {
    failure.confirmed = confirmed;
    throw failure;
  }
}

class GrowthlabCartExtras extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.addEventListener('click', async event => {
      const button = event.target.closest('[data-extra-add]');
      if (!button || this.busy) return;
      this.busy = true;
      const buttons = [...this.querySelectorAll('[data-extra-add]')];
      buttons.forEach(item => { item.disabled = true; });
      const status = this.querySelector('[data-extra-status]');
      status.textContent = this.dataset.adding;
      try {
        await addToDrawer([{id:Number(button.dataset.extraAdd),quantity:1}], this.dataset.addUrl, this.dataset.cartUrl);
        status.textContent = '';
      } catch (failure) {
        status.textContent = failure.confirmed ? this.dataset.added : (failure.rejected ? failure.message : this.dataset.uncertain);
        this.querySelector('[data-extra-cart-link]').hidden = false;
      } finally {
        this.busy = false;
        buttons.forEach(item => { item.disabled = false; });
      }
    });
  }
}
if (!customElements.get('growthlab-cart-extras')) customElements.define('growthlab-cart-extras', GrowthlabCartExtras);
